// src/context/AlertContext.js
import React, { createContext, useContext, useState } from 'react';
import AlertPopup from '../components/common/AlertPopup';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({ show: false, title: '', message: '', buttonLabel: '', redirectUrl: '', onCloseCallback: null });

  const showAlert = (title, message, buttonLabel = '', redirectUrl = '', onCloseCallback = null) => {
    setAlert({
      show: true,
      title,
      message,
      buttonLabel,
      redirectUrl,
      onCloseCallback
    });
  };

  const closeAlert = () => {
    if (alert.onCloseCallback) {
      alert.onCloseCallback();
    }
    setAlert({ show: false, title: '', message: '', buttonLabel: '', redirectUrl: '', onCloseCallback: null });
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert.show && (
        <AlertPopup
          title={alert.title}
          message={alert.message}
          buttonLabel={alert.buttonLabel}
          redirectUrl={alert.redirectUrl}
          onClose={closeAlert}
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
